import React from "react";
import HeartIcon from "../../icons/heart.icon";

interface FooterNavItem {
  text: string;
  href: string;
}

interface FooterNavigationProps {
  className?: string;
}

function FooterNavigation({ className = "" }: FooterNavigationProps) {
  // Navigation items with Chinese text
  const footerNavItems: FooterNavItem[] = [
    { text: "瓹窿瓹罅既故事", href: "/article/about" },
    { text: "門市資料", href: "/article/stores" },
    { text: "家家浪接浪", href: "/article/charity" },
    { text: "環保行動", href: "/article/recycle" },
  ];

  return (
    <footer className={`w-full bg-guru-liver text-white py-4 sm:py-6 md:py-8 mt-auto pl-0 ${className}`}>
      <div className="max-w-7xl mx-auto">
        {/* Adjust grid layout for better mobile display */}
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {footerNavItems.map((item, index) => (
            <div
              key={index}
              // Improve spacing and alignment for mobile
              className="flex flex-col items-center justify-center text-center p-2 sm:p-3"
            >
              <a
                href={item.href}
                className="group relative inline-flex flex-col items-center transition-all duration-300 hover:text-white/90"
                // Add aria-label for accessibility
                aria-label={item.text}
              >
                <HeartIcon
                  // Adjust icon size for different screen sizes
                  className="h-4 w-4 sm:h-5 sm:w-5 mb-1 sm:mb-2 transform transition-transform duration-300 group-hover:scale-110 fill-white"
                />
                {/* Make text responsive */}
                <span className="text-base sm:text-lg font-medium break-words">{item.text}</span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default FooterNavigation;
